import {ref} from 'vue'
import {setToken, removeToken} from "../utils/auth";
import userSvs from '../service/user';

let user = ref({});

const updateUser = function (result) {
    if (result.data) {
        user.value = result.data
    }
}

const logout = (args) => {
    userSvs.logout().then(result => {
        removeToken();
        if (args.callback) {
            args.callback();
        }
    });
};

const checkout = (args) => {
    userSvs.check(window.Kf.prodCode).then(res => {
        const _code = res.kfSysCode;
        if (_code === 0) {
            user.value = res.data
            setToken(res.kfSysMsg);
        } else {
            removeToken();
        }
        if (args.callback) {
            args.callback(_code, res.kfSysMsg);
        }
    }, err => {
        console.error(err);
        removeToken();
        if (args.errCatch) {
            args.errCatch(err);
        }
    });
}


export default {
    user,
    updateUser, logout, checkout,
}